import { render, staticRenderFns } from "./ManageUserRoles.vue?vue&type=template&id=bc53260c&scoped=true&"
import script from "./ManageUserRoles.vue?vue&type=script&lang=js&"
export * from "./ManageUserRoles.vue?vue&type=script&lang=js&"
import style0 from "./ManageUserRoles.vue?vue&type=style&index=0&id=bc53260c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc53260c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc53260c')) {
      api.createRecord('bc53260c', component.options)
    } else {
      api.reload('bc53260c', component.options)
    }
    module.hot.accept("./ManageUserRoles.vue?vue&type=template&id=bc53260c&scoped=true&", function () {
      api.rerender('bc53260c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projectsettings/ManageUserRoles.vue"
export default component.exports